import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  BooleanField,
  FunctionField,
  EditButton,
  DeleteButton,
} from 'react-admin';

export const DeliveryZoneList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="id" label="ID" />
      <TextField source="name" label="Название" />
      <FunctionField
        label="Зона"
        render={(record: any) =>
          record.polygon && record.polygon.length >= 3
            ? `Полигон (${record.polygon.length} вершин)`
            : record.centerLat
              ? `Круг (${record.radiusMeters}м)`
              : '—'
        }
      />
      <NumberField source="deliveryPrice" label="Стоимость доставки" />
      <BooleanField source="isActive" label="Активна" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);
